import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { TokenStorageService } from '../services/token.storage.service';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const tokenStorageService = inject(TokenStorageService);
  const router = inject(Router);
  const token = tokenStorageService.getToken();

  let authReq = req;
  if (token) {
    authReq = req.clone({
      headers: req.headers.set('Authorization', `Bearer ${token}`)
    });
  }

  return next(authReq).pipe(
    catchError((error) => {

      const errorMessage = error.error?.message || error.message || '';

      if (
        errorMessage.includes('JWT expired') ||
        errorMessage.includes('Access denied') ||
        error.status === 401 ||
        error.status === 403
      ) {

        tokenStorageService.logout();

        const currentUrl = router.url;
        if (!currentUrl.includes('/login')) {
          router.navigate(['/login']);
        }
      }

      return throwError(() => error);
    })
  );
};
